import { render } from "./COIMain.vue?vue&type=template&id=ea92911e"
import script from "./COIMain.vue?vue&type=script&lang=js"
export * from "./COIMain.vue?vue&type=script&lang=js"

import "./COIMain.vue?vue&type=style&index=0&id=ea92911e&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__